import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { upDirection, downDirection } from '../../../Common/constants';
import { setGridSortCriteria } from '../../actions';
import { getRequiredFieldsGridSortCriteria } from '../../selectors';

const useRequiredFieldsList = () => {
  const { sortByColumn, sortDirection } = useSelector(getRequiredFieldsGridSortCriteria);
  const dispatchGridSortCriteria = useAction(setGridSortCriteria);

  const handleColumnClick = ({ headerName, direction }) => {
    dispatchGridSortCriteria({
      sortByColumn: headerName,
      sortDirection: direction === upDirection ? downDirection : upDirection,
    });
  };

  return {
    handleColumnClick,
    sortByColumn,
    sortDirection,
  };
};

export default useRequiredFieldsList;
